module.exports = __webpack_public_path__ + "static/media/Clave808.57a079e5.wav";